import { format, Locale } from 'date-fns';
import { sv, enUS, fr } from 'date-fns/locale';

const localeMap: { [key: string]: Locale } = {
    'en-US': enUS,
    'fr-FR': fr,
    'sv-SE': sv,
    'sv': sv,
};

export const formatDate = (date: string, locale: string) => {
    const userLocale = localeMap[locale] || enUS;
    return format(new Date(date), 'PPP', { locale: userLocale });
};